module.exports = __webpack_public_path__ + "assets/img/27@3x.4742ae3b.png";